<template>
  <div class="documents__list">
    <vs-table stripe :data="documents" search  @dblSelection="rowDblClickHandler">
      <template slot="header">
        <h3>Documents ({{ documents.length }})</h3>
      </template>
      <template slot="thead">
        <vs-th>File</vs-th>
        <vs-th sort-key="desc">Description</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="tr.id"
          v-for="tr in data"
         
        >
          <vs-td :data="getFile(tr)">
            <span class="file-name">{{
              getFile(tr) ? getFile(tr).name : '—'
            }}</span>
          </vs-td>
          <vs-td :data="tr.desc" class="desc-cell">{{ tr.desc || '—' }}</vs-td>
          <vs-td :data="tr.id" class="actions-cell">
            <vs-dropdown vs-custom-content>
              <vs-button
                class="btn-drop"
                type="flat"
                color="dark"
                icon="more_horiz"
                title="Options"
              ></vs-button>
              <vs-dropdown-menu class="document-options-menu">
                <vs-dropdown-item v-if="$can('manage', 'document')">
                  <div class="document-meta">
                    <span class="document-meta__row">
                      <span class="document-meta__label">Author:</span>
                      <span>{{
                        tr.owner && tr.owner.nickname ? tr.owner.nickname : '—'
                      }}</span>
                    </span>
                    <span class="document-meta__row">
                      <span class="document-meta__label">Created:</span>
                      <span v-if="tr.created">{{
                        $moment(tr.created * 1000).format('DD.MM.YYYY HH:mm')
                      }}</span>
                      <span v-else>—</span>
                    </span>
                  </div>
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <vs-button
                    type="flat"
                    color="dark"
                    icon="download"
                    size="small"
                    @click="downloadHandler(tr)"
                    >Download</vs-button
                  >
                </vs-dropdown-item>
                <vs-dropdown-item v-if="isPdf(tr)">
                  <vs-button
                    type="flat"
                    color="dark"
                    icon="visibility"
                    size="small"
                    @click="viewHandler(tr)"
                    >View PDF</vs-button
                  >
                </vs-dropdown-item>
                <vs-dropdown-item v-if="$can('manage', 'document')">
                  <vs-button
                    type="flat"
                    color="danger"
                    icon="delete"
                    size="small"
                    @click="deleteHandler(tr.id)"
                    >Delete</vs-button
                  >
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      selectedId: null,
      proxy: process.env.VUE_APP_PROXY,
    }
  },
  computed: {
    ...mapState({
      documents: state => state.documents.documents,
    }),
  },
  methods: {
    getFile: function(tr) {
      return tr.files && tr.files.length ? tr.files[0] : null
    },
    isPdf: function(tr) {
      const file = this.getFile(tr)
      return file ? this.getFileExt(file.name).toLowerCase() === 'pdf' : false
    },
    getFileExt: function(filename) {
      return filename.split('.').pop()
    },
    rowDblClickHandler: function(tr) {
      if (this.isPdf(tr)) {
        this.viewHandler(tr)
      } else {
        this.downloadHandler(tr)
      }
    },
    downloadHandler: function(tr) {
      const file = this.getFile(tr)
      if (!file) return
      fetch(this.proxy + file.file_path)
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob)
          var link = document.createElement('a')
          link.setAttribute('download', file.name)
          link.setAttribute('hidden', true)
          link.href = url
          document.body.appendChild(link)
          link.click()
          link.remove()
          URL.revokeObjectURL(url)
        })
    },
    viewHandler: function(tr) {
      const file = this.getFile(tr)
      if (!file) return
      window.open(this.proxy + file.file_path, '_blank')
    },
    deleteHandler: function(id) {
      this.selectedId = id
      this.openAlert()
    },
    openAlert: function() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Delete document',
        text: 'Are you sure you want to delete the document?',
        accept: this.acceptAlert,
      })
    },
    acceptAlert: function() {
      this.$emit('deleteDocument', this.selectedId)
      this.selectedId = null
    },
  },
}
</script>

<style lang="scss">
.documents__list {
  .file-name {
    word-break: break-all;
    max-width: 12rem;
    display: inline-block;
  }
  .desc-cell {
    max-width: 20rem;
  }
  .actions-cell {
    width: 3rem;
  }
}
.document-options-menu {
  width: 200px;
  .vs-button {
    float: none !important;
    width: 100%;
    justify-content: flex-start;
  }
  .document-meta {
    user-select: none;
    pointer-events: none;
    font-size: 0.85rem;
    line-height: 1.6rem;
    .document-meta__row {
      display: block;
      white-space: nowrap;
    }
    .document-meta__label {
      font-weight: 600;
      margin-right: 0.3rem;
    }
  }
}
</style>
